import React from "react";
import { hourFormat, dateFormatDDmesAnio } from "functions/functions";
import "./cardCanales.sass";

export default function CardCanales({ titulo, horaInicio, horaFin, colorFondo, colorFuente, activo, elementos }) {

    return (
        <a key={titulo+ "-" + elementos.code} target="_top" href={elementos.redirectChanel} className={"container-card-chanel"} style={{background: activo ? "#"+colorFondo : "#f1f1f1", color: activo ? "#"+colorFuente : "#333"}}>

            <div className="seccion-contenido">
                <div className="contenido-date-canal">
                    <time dateTime={horaInicio} className="hour">{hourFormat(horaInicio)}</time> -
                    <time dateTime={horaFin} className="hour">{hourFormat(horaFin)}</time>
                </div>

                <h3 className={"contenido-resumen-canal"}>{titulo}</h3>

                <h4 className="contenido-title-canal">{dateFormatDDmesAnio(horaInicio)}</h4>

            </div>
        </a>
    )
}